// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	LoginbereichBlock: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "LoginbereichBlock" */
				'./index'
			),
	} ),
};
